import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import IMeasurement from "../interfaces/IMeasurement";
import * as moment from 'moment';


@Injectable()
class MeasurementDataProvider{

    private baseURL: string = "";

    constructor(private http: Http) {

    }

    getDate(measurement: IMeasurement) {
        return moment(measurement.timestamp).format('DD/MM/YYYY HH:mm');
    }

    resultToString(measurement: IMeasurement) {
        return `${measurement.result} ${measurement.unit}`
    }

    get():any {
        return this.http.get(this.baseURL).map((res: any) => {
            return res.json();
        });
    }

}

export default MeasurementDataProvider;


// WEBPACK FOOTER //
// ./src/app/services/measurementDataProvider.service.ts